import React, { useEffect, useState } from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import { Box } from "@material-ui/core";
import useStyles from "../common/Styles";
import { useSelector } from "react-redux";
import { toolbarHeight } from "components/app/Styles";
import { filterContainerHeight, chartTitleHeight } from "../common/Styles";
import { getWindowSize } from "../common/utils";
// import userActions from "../common/actions";
import useGetViewPortDimensions from "hooks/useGetViewPortDimensions";

const AgricultureDonut = () => {
  const { district_water, 
    // districts,
    agriculture_selected } = useSelector(
    (state) => state.water_user
  );
  const [windowSize, setWindowSize] = useState(getWindowSize());
  const classes = useStyles();
  // const { setWaterUserOption } = userActions();
  const { isMobile } = useGetViewPortDimensions();

  // useEffect(() => {
  //   setWaterUserOption(districts);
  // }, [districts]);

  const options = {
    chart: {
      type: "pie",
      plotBackgroundColor: "transparent",
      backgroundColor: "transparent",
      height:
        windowSize.innerHeight -
        toolbarHeight -
        filterContainerHeight -
        chartTitleHeight -
        75,
        ...(isMobile && { width: 380 })
    },
    title: {
      text: undefined,
    },
    series: [
      {
        name: "District Water Usage",
        innerSize: "70%",
        data: [
          {
            name: "Other Surface Water",
            y: Math.round(
              district_water[agriculture_selected.name].agua_fria +
                district_water[agriculture_selected.name].gila +
                district_water[agriculture_selected.name].santa_cruz
            ),
            color: "#D88C31",
          },
          {
            name: "Salt & Verde",
            y: Math.round(
              district_water[agriculture_selected.name].salt_and_verde
            ),
            color: "#FFB607",
          },
          {
            name: "Colorado River",
            y: Math.round(
              district_water[agriculture_selected.name].colorado_river
            ),
            color: "#6AA4DC",
          },
          {
            name: "Reclaimed Water",
            y: Math.round(
              district_water[agriculture_selected.name].reclaimed_water
            ),
            color: "#DE3E40",
          },
          {
            name: "Ground water",
            y: Math.round(
              district_water[agriculture_selected.name].groundwater
            ),
            color: "#2352D0",
          },
        ],
      },
    ],
    credits: {
      enabled: false,
    },
    plotOptions: {
      pie: {
        dataLabels: {
          enabled: false,
        },
        states: {
          hover: {
            enabled: false,
          },
          inactive: {
            opacity: 1,
          },
        },
        borderWidth: 0,
        showInLegend: true,
      },
      series: {
        point: {
          events: {
            legendItemClick: function () {
              return false; // <== returning false will cancel the default action
            },
          },
        },
      },
    },
    tooltip: {
      padding: 16,
      backgroundColor: "#FFF",
      borderRadius: 8,
      useHTML: true,
      style: { color: "#000", fontFamily: "'Arial', sans-serif" },
      formatter() {
        return false;
      },
    },
    legend: {
      itemStyle: {
        color: "#333333",
        fontSize: "12px",
        fontWeight: "normal",
        fontFamily: "Arial",
      },
      align: "center",
      backgroundColor: "#FFFFFF",
      borderColor: "#E0E0E0",
      borderWidth: 1,
      borderRadius: 15,
      //   width: "25%",
      padding: 10,
      itemMarginTop: 5,
      itemMarginBottom: 5,
      shadow: {
        offsetX: -1,
        offsetY: 3,
        color: "#00000029",
        width: 4,
      },
      reversed: true,
    },
  };

  //gets windowSize to set width of barchart
  useEffect(() => {
    const handleWindowResize = () => {
      setWindowSize(getWindowSize());
    };
    window.addEventListener("resize", handleWindowResize);
    return () => {
      window.removeEventListener("resize", handleWindowResize);
    };
  }, []);
  return (
    <Box className={classes.chartContainer}>
      <HighchartsReact highcharts={Highcharts} options={options} />
    </Box>
  );
};

export default AgricultureDonut;
